import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { GlobalNetworkActivityType } from '../schemas/global-activity'

export const globalActivity = createQueryKeys('globalActivity', {
  list: (userId?: number, activityType?: GlobalNetworkActivityType, limit?: number, skip?: number) => [
    userId,
    activityType,
    limit,
    skip,
  ],
  detail: (activityId: number) => [activityId],
})
